import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { IScrollThumbControllerOptions, ScrollThumbController } from "./ScrollThumbController";
export interface IScrollControllerOptions {
    onScroll: (percent: number) => {}
}

export class ScrollController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IScrollControllerOptions) {
        super("ScrollController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {
                ScrollThumb: {
                    instanceName: 'scroll_thumb',
                    view: ScrollThumbController,
                    model: this.$model,
                    options: <IScrollThumbControllerOptions>{
                        onScroll: (percent) => {
                            this._options.onScroll(percent);
                        }
                    }
                }
            }
        };
    }

    protected onInitialize(): void {

    }

    public reset() {
        this.$childControllers.get<ScrollThumbController>('ScrollThumb').reset();
    }
}